import { updateConfiguration } from '../../../../../api/simple-project-service/configurations/updateConfiguration';
import { updatePublicConfiguration } from '../../../../../api/simple-project-service/configurations/updatePublicConfiguration';
import { CameraAction } from '../../../../../configurator/controllers/cameraController';
import { RequiredArticle } from '../../../../../interfaces/Article';
import Store from '../../../../../interfaces/Store';
import {
  MultipleViolationsError,
  validationService,
} from '../../../../../services/validationService';
import { NotificationFactory } from '../../../../../utils/factories/notificationFactory';
import { ActionType } from '../../../../actions';
import { addNotifications } from '../../../../notifications/notifications.actions';
import { selectArticle } from '../../../../selection/selection.actions';
import {
  disableInteractions,
  enableInteractions,
} from '../../../../suppressInteractions/suppressInteractions.actions';
import { replaceRequiredLightingArticleInConfiguration } from './replaceRequiredLightingArticleInConfiguration';

const REPLACE_REQUIRED_LIGHTING_ARTICLE = 'replaceRequiredLightingArticle';

const handleProductCannotBeAddedError = (dispatch, name) => {
  dispatch(addNotifications([NotificationFactory.productCannotBeAddedAutomatically(name)]));
  dispatch(enableInteractions(REPLACE_REQUIRED_LIGHTING_ARTICLE));
};

const dispatchError = (dispatch: any, error: Error) => {
  if (error instanceof MultipleViolationsError) {
    dispatch(addNotifications([NotificationFactory.multipleViolations(error.violations)]));
  } else {
    dispatch(addNotifications([NotificationFactory.customNegative(error.message)]));
  }
  dispatch(enableInteractions(REPLACE_REQUIRED_LIGHTING_ARTICLE));
};

export const replaceRequiredLightingArticle = (
  oldArticleId: string,
  newArticle: RequiredArticle,
) => {
  return async (dispatch, getState: () => Store, { loggedIn }) => {
    dispatch(disableInteractions(REPLACE_REQUIRED_LIGHTING_ARTICLE));
    const oldArticle = getState().configuration.getRequiredLightingArticle(oldArticleId);

    if (!oldArticle) {
      return dispatch(enableInteractions(REPLACE_REQUIRED_LIGHTING_ARTICLE));
    }

    try {
      const newSocketType = newArticle.definition.socketType || getState().configuration.socketType;

      const futureConfiguration = replaceRequiredLightingArticleInConfiguration(
        getState().configuration,
        oldArticleId,
        newArticle,
        newSocketType,
      );

      const validationAndLightingSetup = await validationService.validateAndGetLightingSetup(
        futureConfiguration,
      );
      if (validationAndLightingSetup instanceof Error) {
        return dispatchError(dispatch, validationAndLightingSetup);
      }

      await dispatch({
        type: ActionType.REPLACE_ARTICLE,
        payload: {
          configuration: futureConfiguration,
          validationAndLightingSetup,
          setNewSelectedArticleId: newArticle.id,
        },
      });
      await dispatch(
        selectArticle(futureConfiguration.findParentId(newArticle.id), CameraAction.RECENTER),
      );

      dispatch(enableInteractions(REPLACE_REQUIRED_LIGHTING_ARTICLE));

      loggedIn
        ? updateConfiguration(getState().configuration)
        : updatePublicConfiguration(getState().configuration);
    } catch (e) {
      console.warn(e);
      return handleProductCannotBeAddedError(dispatch, oldArticle.definition.displayName);
    }
  };
};
